import React, { useEffect, useState } from "react";
import Person from "../components/Person";
import styles from "./../style/about.module.css"

interface IPerson {
  firstName: string,
  lastName: string,
  middleName?: string,
  title?: string,
  suffix?: string,
  addition?: string,
  position?: string,
  description?: string[],
  imageSrc?: string
}


const About = () => {


  const [leadership, leadershipSet] = useState<IPerson[]>([]);
  const [board, boardSet] = useState<IPerson[]>([]);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/people/team.json')
      .then(response => response.json())
      .then((fetchedData: IPerson[]) => {
        boardSet(fetchedData.filter((item: any) => item.type === 'board'));
        leadershipSet(fetchedData.filter((item: any) => item.type === 'leadership'));
      });
  }, [])

  return (
    <div className={styles.aboutUsContent}>
      <div className={styles.historySection}>
        <div className={styles.historySectionTitle}>About us</div>
        <div className={styles.historySectionText}>
          <p> Antion Biosciences SA is a Swiss biotechnology platform company pioneering next-generation gene modulation technologies for advanced therapeutics and biopharmaceutical innovation. Through our proprietary multiplex gene silencing platform, we enable pharmaceutical and biotechnology partners to engineer biological systems with a level of <strong>precisions</strong>, <strong>control</strong> and <strong> scalability </strong> that was previously unattainable. 
          <br />
          <br />
          Our <strong> modular </strong> and <strong> tunable </strong> technology enables the coordinated regulation of multiple genes, providing a versatile platform for programming therapeutic cells, optimizing biologics manufacturing, and advancing a broad range of next-generation therapeutic and biopharmaceutical applications. By integrating <strong>precision</strong>, <strong>flexibility</strong> and <strong>manufacturability</strong>, we empower our partners to overcome complex biological challenges and accelerate the translation of breakthrough science into transformative medicines. </p>
        </div>
      </div>
      <div className={styles.peopleSection}>
        <div className={`${styles.leadership} ${styles.peopleTitle}`}>Executive Committee</div>
        <div className={`${styles.leadership} ${styles.peopleList}`}>
          {leadership.map(person => (
            <Person firstName={person.firstName} lastName={person.lastName} imageSrc={person.imageSrc} position={person.position} description={person.description} />
          ))}
        </div>
        <div className={`${styles.board} ${styles.peopleTitle}`}>Board of Directors</div>
        <div className={`${styles.board} ${styles.peopleList}`}>
          {board.map(person => (
            <Person firstName={person.firstName} lastName={person.lastName} imageSrc={person.imageSrc} position={person.position} description={person.description} />
          ))}
        </div>
      </div>
    </div >
  )
}

export default About